import { render, staticRenderFns } from "./NewEdmCampaign.vue?vue&type=template&id=5d492ce2&scoped=true&"
import script from "./NewEdmCampaign.vue?vue&type=script&lang=js&"
export * from "./NewEdmCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d492ce2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
